export const APPLICATION_LIST_SUCCESS = 'APPLICATION_LIST_SUCCESS';
export const APPLICATION_LIST_LOADING = 'APPLICATION_LIST_LOADING';
export const APPLICATION_LIST_FAILED = 'APPLICATION_LIST_FAILED';
export const APPLICATION_LIST_LOADDATA = 'APPLICATION_LIST_LOADDATA';

export const APPLICATION_SHOW_MODAL = 'APPLICATION_SHOW_MODAL';
export const APPLICATION_HIDE_MODAL = 'APPLICATION_HIDE_MODAL';
export const APPLICATION_MODAL_LOADING = 'APPLICATION_MODAL_LOADING';

export const APPLICATION_STAGE_LOADDATA = 'APPLICATION_STAGE_LOADDATA';
export const APPLICATION_STAGE_SUCCESS = 'APPLICATION_STAGE_SUCCESS';

export const APPLICATION_STATUS_CHANGE = 'APPLICATION_STATUS_CHANGE';
export const APPLICATION_STATUS_SUCCESS = 'APPLICATION_STATUS_SUCCESS';


export const APPLICATION_ASSIGN = 'APPLICATION_ASSIGN';
export const APPLICATION_ASSIGN_SUCCESS = 'APPLICATION_ASSIGN_SUCCESS';
export const APPLICATION_SHOW_ASSIGN_MODAL = 'APPLICATION_SHOW_ASSIGN_MODAL';
export const APPLICATION_HIDE_ASSIGN_MODAL = 'APPLICATION_HIDE_ASSIGN_MODAL';
export const APPLICATION_MODAL_ASSIGN_LOADING = 'APPLICATION_MODAL_ASSIGN_LOADING';



export const APPLICATION_CALLNUMBER = 'APPLICATION_CALLNUMBER';
export const APPLICATION_CALLNUMBER_SUCCESS = 'APPLICATION_CALLNUMBER_SUCCESS';
export const APPLICATION_CALLNUMBER_FAILED = 'APPLICATION_CALLNUMBER_FAILED';
export const APPLICATION_SHOW_CALLNUMBER_MODAL = 'APPLICATION_SHOW_CALLNUMBER_MODAL';
export const APPLICATION_HIDE_CALLNUMBER_MODAL = 'APPLICATION_HIDE_CALLNUMBER_MODAL';
export const APPLICATION_MODAL_CALLNUMBER_LOADING = 'APPLICATION_MODAL_CALLNUMBER_LOADING';